import React from 'react';
import { FormattedMessage } from 'react-intl';

import { LoginType } from '../../../../utilities/social-login';

export const ConfirmationFormTitleText = ({
  loginType,
  createNeeded,
}: {
  loginType: LoginType;
  createNeeded: boolean;
}) => {
  switch (loginType) {
    case LoginType.GoogleButton:
    case LoginType.GoogleOneTap:
      if (createNeeded) {
        return (
          <FormattedMessage
            id="account.creation.confirmation.explanation.google"
            defaultMessage="We'll use your details from Google to create an account:"
          />
        );
      } else {
        return (
          <FormattedMessage
            id="account.verification.confirmation.explanation.google"
            defaultMessage="To keep your account secure, please verify your login."
          />
        );
      }
    case LoginType.Apple:
      return (
        <FormattedMessage
          id="account.creation.confirmation.explanation.apple"
          defaultMessage="We'll use your details from Apple to create an account:"
        />
      );
    case LoginType.Slack:
      return (
        <FormattedMessage
          id="account.creation.confirmation.explanation.slack"
          defaultMessage="We'll use your details from Slack to create an account for:"
          description="Message shown to the user when they're creating an account using their Slack credentials"
        />
      );
    case LoginType.Microsoft:
      if (createNeeded) {
        return (
          <FormattedMessage
            id="account.creation.confirmation.explanation.microsoft"
            defaultMessage="We'll use your details from Microsoft to create an account:"
          />
        );
      } else {
        return (
          <FormattedMessage
            id="account.verification.confirmation.explanation.microsoft"
            defaultMessage="We were unable to verify the email associated with your Microsoft account, so let's do that now."
          />
        );
      }
    case LoginType.SSO:
      return (
        <FormattedMessage
          id="account.creation.confirmation.explanation.sso"
          defaultMessage="We'll use the details from your single sign-on provider to create an account. Contact your administrator if you want to change them."
        />
      );
    default:
      return null;
  }
};
